/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client.


/*
 * EXPORTS
 */
export default gql`
mutation PhoneNumberoReplacementDeleteManyMutation($phoneNumberoReplacementIds: [ID]!) {
  PhoneNumberoReplacementDeleteMany(phoneNumberoReplacementIds: $phoneNumberoReplacementIds) {
    message
    status
  }
}
`
